import { Check, X } from "lucide-react";
import { useEffect, useState } from "react";

const prices = [
  {
    label: "Unterstufe",
    grades: "Klasse 6–7",
    price: "20",
    description: "Grundlagen festigen, Hausaufgaben sicher bearbeiten und wieder Vertrauen in Mathe gewinnen.",
    topics: ["Brüche, Dezimalzahlen und Prozentrechnung", "Terme und einfache Gleichungen", "Geometrische Grundlagen", "Rechenstrategien für Hausaufgaben"],
    support: "Wir bauen fehlende Grundlagen in Ruhe auf, erklären jeden Schritt anschaulich und üben so lange, bis du Aufgaben selbstständig lösen kannst.",
  },
  {
    label: "Mittelstufe",
    grades: "Klasse 8–10",
    price: "25",
    description: "Lücken schließen, neue Themen verstehen und dich gezielt auf Klassenarbeiten vorbereiten.",
    topics: ["Lineare und quadratische Funktionen", "Gleichungssysteme und Geometrie", "Potenzen, Wurzeln und Stochastik", "Vorbereitung auf Klassenarbeiten"],
    support: "Wir schließen gezielt Lücken, entwickeln klare Lösungswege und trainieren an passenden Aufgaben für deine nächste Klassenarbeit.",
  },
  {
    label: "Oberstufe",
    grades: "Klasse 11–Abitur",
    price: "30",
    description: "Anspruchsvolle Themen durchdringen und dich strukturiert auf Klausuren und das Abitur vorbereiten.",
    topics: ["Analysis: Ableitungen und Integrale", "Analytische Geometrie und Vektoren", "Stochastik und Wahrscheinlichkeitsrechnung", "Klausur- und Abiturvorbereitung"],
    support: "Wir ordnen komplexe Themen, trainieren typische Aufgabentypen und entwickeln eine verlässliche Strategie für Klausuren und das Abitur.",
  },
];

export function PricingSection() {
  const [selectedPrice, setSelectedPrice] = useState<(typeof prices)[number]>();

  useEffect(() => {
    if (!selectedPrice) return;
    const closeOnEscape = (event: KeyboardEvent) => { if (event.key === "Escape") setSelectedPrice(undefined); };
    document.addEventListener("keydown", closeOnEscape);
    return () => document.removeEventListener("keydown", closeOnEscape);
  }, [selectedPrice]);

  return (
    <>
      <section className="pricing-section section-pad" id="preise" aria-labelledby="pricing-title">
      <div className="section-heading centered">
        <div className="eyebrow">Transparent und fair</div>
        <h2 id="pricing-title">Transparente Preise für deinen Lernweg.</h2>
        <p>Der Preis richtet sich nach Klassenstufe und fachlichem Anspruch. Alle Einheiten dauern 60 Minuten; die erste Probestunde mit 45 Minuten ist kostenlos.</p>
      </div>
      <div className="pricing-grid">
        {prices.map((item) => (
          <button className="pricing-card" key={item.label} type="button" onClick={() => setSelectedPrice(item)} aria-label={`Details zu ${item.label}, ${item.grades}`}>
            <span className="pricing-label">{item.label}</span>
            <h3>{item.grades}</h3>
            <div className="pricing-amount"><strong>{item.price} €</strong><span>/ 60 Min.</span></div>
            <p>{item.description}</p>
            <ul>
              <li><Check size={16} /> Online per Google Meet</li>
              <li><Check size={16} /> Digitales Whiteboard</li>
            </ul>
            <span className="pricing-more">Mehr zu dieser Stufe <span aria-hidden="true">→</span></span>
          </button>
        ))}
      </div>
      </section>

      {selectedPrice && (
        <div className="pricing-modal-backdrop" role="presentation" onMouseDown={(event) => { if (event.currentTarget === event.target) setSelectedPrice(undefined); }}>
          <div className="pricing-modal" role="dialog" aria-modal="true" aria-labelledby="pricing-modal-title">
            <button className="pricing-modal-close" type="button" onClick={() => setSelectedPrice(undefined)} aria-label="Details schließen"><X /></button>
            <span className="pricing-label">{selectedPrice.label}</span>
            <h2 id="pricing-modal-title">{selectedPrice.grades}</h2>
            <div className="pricing-modal-price"><strong>{selectedPrice.price} €</strong><span>/ 60 Minuten</span></div>
            <h3>Typische Themen</h3>
            <ul className="pricing-topics">{selectedPrice.topics.map((topic) => <li key={topic}><Check size={17} /> {topic}</li>)}</ul>
            <h3>So helfe ich dir</h3>
            <p>{selectedPrice.support}</p>
            <a className="button button-primary full-width" href="#booking" onClick={() => setSelectedPrice(undefined)}>Kostenlose Probestunde anfragen</a>
          </div>
        </div>
      )}
    </>
  );
}
